import SelectWidget from '../SelectWidget/SelectWidget';
import TextWidget from '../TextWidget/TextWidget';

export default { SelectWidget, TextWidget };
